import Vue from 'vue';
import Vuex from 'vuex';
import groupApi from '../api/group-api';

Vue.use(Vuex);

const initialState = () => {
  return {
    groupList: [],
  };
};

const getters = {
  getGroupList(state) {
    return state.groupList;
  },
};

const mutations = {
  setGroupList(state, groupList) {
    state.groupList = groupList;
  },
  setGroupVisible(state, { groupId, isVisible }) {
    let groupIndex = state.groupList.findIndex((groupInfo) => {
      return groupInfo.id === groupId;
    });

    state.groupList[groupIndex]['starred'] = isVisible;
  },
};

const actions = {
  async loadGroupList({ commit }) {
    return new Promise((resolve) => {
      commit('setGroupList', []);
      groupApi
        .loadGroupList()
        .then((apiResponse) => {
          let data = apiResponse.data.data;
          commit('setGroupList', data);
        })
        .finally(() => {
          resolve();
        });
    });
  },
  async setGroupVisible({ commit }, { groupId, isVisible }) {
    commit('setGroupVisible', { groupId, isVisible });
    return groupApi.setGroupVisible(groupId);
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
};
